import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";
export default function FirmLogin() {
  const nav = useNavigate();
  const [login_id, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/firms/login", { login_id, password });
      localStorage.setItem("firm_token", data.firm_token);
      localStorage.setItem("firm_token_name", data.firm_name);
      localStorage.setItem("firm_id", data.firm_id);
      localStorage.setItem("companies_json", JSON.stringify(data.companies || []));
      localStorage.removeItem("company_id");
      localStorage.removeItem("company_name");
      toast.success("Firm authenticated. Choose company.");
      nav("/firm/company-select");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-border rounded-lg p-8">
        <div className="overline mb-2">Firm Login</div>
        <h1 className="text-3xl font-bold tracking-tight">Welcome back</h1>
        <div className="mt-6 space-y-4">
          <div>
            <Label>Login ID</Label>
            <Input value={login_id} onChange={(e) => setLogin(e.target.value)} data-testid="firm-login-id" />
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="firm-login-password" />
          </div>
          <Button className="btn-primary w-full" disabled={busy} onClick={submit} data-testid="firm-login-submit">
            {busy ? "..." : "Continue"}
          </Button>
          <div className="text-sm text-center flex flex-col gap-1">
            <Link to="/firm/signup" className="text-[#064E3B] underline">Register a new firm</Link>
            <button type="button" onClick={async () => {
              const login_id_v = login_id || window.prompt("Enter your firm login ID:");
              if (!login_id_v) return;
              const role = window.prompt("Which password? Type: firm / owner / accountant", "firm");
              if (!role) return;
              const username = role !== "firm" ? window.prompt("Username (owner/accountant username):") : "";
              const contact = window.prompt("Your contact number for admin to WhatsApp back:", "");
              try {
                await api.post("/forgot-password", { login_id: login_id_v, role, username: username || null, contact: contact || null });
                toast.success("Request submitted. Super admin will contact you shortly.");
              } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
            }} className="text-xs text-slate-500 underline" data-testid="forgot-password-btn">Forgot password?</button>
          </div>
        </div>
      </div>
    </div>
  );
}
